/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import template from './workspace-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {ADMIN_RESOURCE_PAGES} from '../common/controller/admin-resource-pages';
import {APP_SHARED} from '../common/app-shared';
import {WorkspaceApiService, WorkspaceModel} from './workspace-api.service';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, ...ADMIN_RESOURCE_PAGES],
  selector: 'adn-workspace-list-page',
  template
})
export class WorkspaceListPageComponent implements OnInit {
  readonly itemStateName = 'app.wor.workspaces.workspace';

  columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: '', label: 'type', sortable: false}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<WorkspaceModel>(
    inject(WorkspaceApiService),
    {listId: 'workspaceList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
